import { render, staticRenderFns } from "./QuotePartsSalaries.vue?vue&type=template&id=706f13f4&scoped=true"
import script from "./QuotePartsSalaries.vue?vue&type=script&lang=js"
export * from "./QuotePartsSalaries.vue?vue&type=script&lang=js"
import style0 from "./QuotePartsSalaries.vue?vue&type=style&index=0&id=706f13f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706f13f4",
  null
  
)

export default component.exports